export default function (overwrites) {
  return {
    id: null,
    name: null,
    ...overwrites,
  }
}
